import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=1726b606&scoped=true&"
import script from "./Recommend.vue?vue&type=script&lang=js&"
export * from "./Recommend.vue?vue&type=script&lang=js&"
import style0 from "./Recommend.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Recommend.vue?vue&type=style&index=1&id=1726b606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726b606",
  null
  
)

export default component.exports